// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G2CJ","tabsBox":"styles_tabsBox__2YeHc","createButton":"styles_createButton__1VWqB"};